import {
  Button,
  Flex,
  Icon,
  Modal,
  Stack,
  Text,
  useToast,
} from '@pairy/pds-react';
import Image from 'next/image';
import copy from 'copy-to-clipboard';

import { SetState } from '@/types/helper';
import getEmailThumbnailLink from '@/utils/getEmailThumbnailLink';

import * as Styled from './index.styles';

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: SetState<boolean>;
  thumbnailImgUrl: string;
  title: string;
  link: string;
  totalCount: number;
}

const EmailThumbnailModal = ({
  isModalOpen,
  setIsModalOpen,
  title,
  thumbnailImgUrl,
  link,
  totalCount,
}: Props) => {
  const toast = useToast();

  const handleEmailLinkCopyClick = () => {
    const emailThumbnailUrl = getEmailThumbnailLink({
      thumbnailImgUrl,
      title,
      link,
      totalCount,
    });
    copy(emailThumbnailUrl, { format: 'text/html' });
    toast('복사되었습니다');
  };

  return (
    <Modal.Root
      open={isModalOpen}
      onOpenChange={(open) => {
        setIsModalOpen(open);
      }}
    >
      <Modal.Content>
        <Modal.Header title="이메일에 붙여넣기" />
        <Modal.Body>
          <Stack gap={16} direction="column">
            <Flex justifyContent="space-between">
              <Text variant="md-semibold" color="black">
                HTML 코드를 복사하여
                <br />
                이메일 본문에 붙여넣으세요.
              </Text>

              <Button
                variant="black_to_zinc_900"
                leftIcon={
                  <Icon icon="ph:image-square" size={17} color="inherit" />
                }
                radius={8}
                paddingX={16}
                paddingY={12}
                textVariant="md-medium"
                width="fit-content"
                onClick={handleEmailLinkCopyClick}
              >
                이메일 첨부용 HTML 코드 복사하기
              </Button>
            </Flex>

            <Styled.GrayContainer
              gap={16}
              alignItems="center"
              width="100%"
              direction="column"
              padding={16}
            >
              <Styled.WhiteContainer gap={16} padding={16} direction="column">
                <Stack gap={8} direction="column">
                  <Styled.ImageContainer>
                    <Image src={thumbnailImgUrl} layout="fill" />
                  </Styled.ImageContainer>
                  <Stack gap={4} direction="column">
                    <Styled.Title
                      variant="md-semibold"
                      color="black"
                      textAlign="center"
                    >
                      {title}
                    </Styled.Title>
                    <Text
                      variant="xs-medium"
                      color="zinc_400"
                      textAlign="center"
                    >
                      총 {totalCount} 페이지
                    </Text>
                  </Stack>
                </Stack>
                <Button
                  variant="skyblue_500_fill"
                  textVariant="sm-semibold"
                  paddingX={16}
                  paddingY={12}
                >
                  첨부된 파일 확인하기
                </Button>
              </Styled.WhiteContainer>
              <Text variant="sm-medium" color="zinc_400" textAlign="center">
                위와 같이 이메일에 첨부됩니다
              </Text>
            </Styled.GrayContainer>
          </Stack>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};

export default EmailThumbnailModal;
